import { EAgentLandingPageType } from './agent-landing-page';
import { ELeadResponseType } from './lead-response';

export enum EAdCampaignStatus {
  PendingBilling = 'PENDING_BILLING',
  PendingMarketingProfile = 'PENDING_MARKETING_PROFILE',
  PendingAdApproval = 'PENDING_AD_APPROVAL',
  Active = 'ACTIVE',
  Paused = 'PAUSED',
}

export interface IAdCampaign {
  _id: string;
  user: {
    _id: string;
    firstName: string;
    lastName: string;
  };
  name: string;
  callToActionLink: string;
  useCustomCallToActionLink: boolean;
  agentLandingPageType?: EAgentLandingPageType;
  zipCodes: string[];
  customAudienceCampaigns: {
    _id: string;
    name: string;
    numSubscribedApns: number;
  }[];
  costs: {
    userMonthlyBudget: number; // User's cost for this ad campaign
    nextInvoiceDate?: Date;
  };
  paymentMethodId?: string;
  latestImagePreviewUrl?: string;
  status: EAdCampaignStatus;
  createdAt: Date;

  stats: IAdCampaignStats;
}

export interface IAdCampaignLead {
  _id: string;
  type: ELeadResponseType;
  date: Date;

  fullName?: string;
  phoneNumber?: string;
  email?: string;
  address?: string;
  message?: string;
  zipCode?: string;
}

export interface IAdCampaignStats {
  reach?: number;
  impressions?: number;
  inlineLinkClicks?: number;
}

export interface CreateAdCampaignDto {
  name: string;
  useCustomCallToActionLink: boolean;
  customCallToActionLink: string;
  budget: number;
  customAudienceCampaignIds: string[];
  zipCodes: string[];
  paymentMethodId: string;
}

export interface UpdateAdCampaignDto {
  name?: string;
  status?: EAdCampaignStatus.Paused | EAdCampaignStatus.Active;
  paymentMethodId?: string;
}
